var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDeleteRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.333,
    height: 17.955,
    viewBox: "0 0 16.333 17.955"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-delete-red_svg__cls-1,.kpmg-delete-red_svg__cls-2{fill:none;stroke:#bc204b;stroke-linecap:round;stroke-width:1.6px}.kpmg-delete-red_svg__cls-2{stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-delete-red_svg__ICN_Sterge_Enabled",
    transform: "translate(-187.7 -262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-red_svg__Line_278",
    d: "M0 0h14.733",
    className: "kpmg-delete-red_svg__cls-1",
    "data-name": "Line 278",
    transform: "translate(188.5 264.833)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-delete-red_svg__Rectangle_410",
    className: "kpmg-delete-red_svg__cls-2",
    "data-name": "Rectangle 410"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9.066v3.4H0z",
    transform: "translate(191.333 262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.8.8h7.466v1.8H.8z",
    transform: "translate(191.333 262)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-red_svg__Line_279",
    d: "M0 0v8.079",
    className: "kpmg-delete-red_svg__cls-1",
    "data-name": "Line 279",
    transform: "translate(194.166 268.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-red_svg__Line_280",
    d: "M0 0v8.079",
    className: "kpmg-delete-red_svg__cls-1",
    "data-name": "Line 280",
    transform: "translate(197.566 268.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-delete-red_svg__Path_932",
    d: "M-6891.694-22779.5l.855 11.689h9.148l.866-11.689",
    className: "kpmg-delete-red_svg__cls-2",
    "data-name": "Path 932",
    transform: "translate(7082.003 23046.969)"
  }))));
}

export default SvgKpmgDeleteRed;